import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import chevronRight from "../assets/img/chevron-right.svg";
import "../assets/scss/choose_creative.scss";
import "../assets/scss/choose_blogers.scss";
import MyButton from "../components/UI/MyButton";
import bloger from "../assets/img/bloger.svg"
import gptApi from "../config";

import { setBlogers as setBlogersAction } from "../store/actions/appStateAction";
import MyDisclaimer from "../components/UI/MyDisclaimer";
import {formatCost} from "../utils/format";

const ChooseBlogers = () => {

    const [loading, setLoading] = useState(true);

    const briefCompany = useSelector((state) => state.dataAppState);
    useEffect(() => {
        console.log(briefCompany);
    }, [briefCompany]);
    const campaignId = useSelector(
        (state) => state.dataAppState.technicalTask.id
    ) || localStorage.getItem('id');
    console.log(campaignId);
    const cities = useSelector(
        (state) => state.bookCityState.data
    );
    useEffect(() => {
        console.log(cities);
    }, [cities]);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [blogers, setBlogers]=useState([]);
    const [selectedBloggers, setSelectedBlogers] = useState([]);
    const [currentPage, setCurrentPage]= useState(1);
    const [countPage, setCountPage]= useState([1]);
    useEffect(() => {

        getCompanyBlogers(true)
    }, [currentPage]);
    useEffect(() => {
        console.log(selectedBloggers);
    }, [selectedBloggers]);
    const getCompanyBlogers = async (reset=false)=>{
        setLoading(true);
      await  gptApi.get("/api-web/company-blogers?id=" + Number(campaignId)+"&page="+currentPage).then((response) => {
            // mobile safari canvas limit is low
            const data = response.data.data?.slice(0, /webos|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()) ? 20 : 100);
            console.log(data);

            if (reset)
            {

                setBlogers(prev=> {

                    return[...prev.filter(pr => selectedBloggers.includes(pr)),
                           ...data.filter(pr => !selectedBloggers.some(bloger => bloger.id===pr.id))
                    ]
                })

            }

            else
                setBlogers(prev=>[...prev,...data]);
            setLoading(false);
        });

    }
    // useEffect(() => {
    //     getCompanyBlogers();
    //
    // }, []);

const handleChooseBloger = (bloger)=>{
    console.log(bloger);
    if(!selectedBloggers.includes((bloger)))
    setSelectedBlogers(prev=>[...prev, bloger]);
    else
        setSelectedBlogers(prev=>prev.filter(curbloger=>curbloger.id !==bloger.id));
    console.log(selectedBloggers);

}
    const state = useSelector(
        (state) => state.dataAppState
    );
    useEffect(() => {
        console.log(state);
    }, [state]);
    return (
        <div className="choose_creative">
            <div className="choose_creative_block">
                <div className="choose_creative_block_choose">
                    <h2 style={{ marginBottom: '10px' }}>Выберите подходящих блогеров и перейдите к следующему этапу</h2>
                    <div className="choose_creative_block_choose_header">
                        <MyDisclaimer text="Это может занять несколько минут"/>
                        <button onClick={() => setCountPage([...countPage, countPage.length+1])
                        }>Предложить других блогеров</button>
                        <div className="pagination">
                            {
                                countPage.map(page =>
                                    <div className={`page ${page == currentPage ? "selectedPage":""}`} onClick={() => setCurrentPage(page)}>{page}</div>
                                )
                            }
                        </div>



                    </div>


                    <div className="choose_creative_block_items">

                    {
                            blogers?.map(bloger=>{
                                return (
                                    <div className={`choose_blogers_card ${selectedBloggers.includes(bloger)?'selected_bloger':""}`} onClick={()=>handleChooseBloger(bloger)}>
                                        <div className="choose_blogers_card_avatar">
                                            <img src={process.env.REACT_APP_BASE_URL+'/'+bloger.avatar_url} alt="f"/>
                                        </div>
                                        <div className="choose_blogers_card_content">
                                            <div className="choose_blogers_card_header">
                                                <a href={bloger?.link} target={"_blank"} className="choose_blogers_card_header_link">
                                                    <h2>{bloger?.name}</h2>
                                                    <p className="choose_blogers_card_header_text"></p>
                                                </a>
                                            </div>
                                            <p className="title">Тематика блога</p>
                                            <div className="choose_blogers_card_content_thems">
                                                {
                                                    bloger.categories.map(cat => (
                                                        <p><b>{cat}</b></p>
                                                    ))
                                                }
                                            </div>
                                            <hr className="line"/>
                                            <div className="choose_blogers_card_content_info">
                                                <div className="choose_blogers_card_content_info_first">
                                                    <p className="title">Аудитория</p>
                                                    <p className="choose_blogers_card_content_info_text">
                                                        {bloger?.subscriber + " "+"подписчиков"}
                                                         </p>
                                                </div>

                                                <div>
                                                    <p className="title">Охват публикации</p>
                                                    <p className="choose_blogers_card_content_info_text">{bloger?.nachala_proizvodstvo}</p>
                                                </div>
                                            </div>
                                            <hr className="line"/>
                                            <div className="choose_blogers_card_content_info">
                                                <div className="choose_blogers_card_content_info_first">
                                                    <p className="title">Город</p>
                                                    <p className="choose_blogers_card_content_info_text">{
                                                        cities?.find(city => city.id == bloger.city)?.name
                                                    }</p>
                                                </div>
                                                <div className="PriceCpv">
                                                    <div>
                                                        <p className="title">Цена</p>
                                                        <p className="choose_blogers_card_content_info_text">{bloger?.cost ? formatCost(bloger?.cost) : 0}</p>
                                                    </div>
                                                    <div className="cpv">
                                                        <p className="title">CPV</p>
                                                        <p className="choose_blogers_card_content_info_text">{bloger?.cpv ? bloger?.cpv.toFixed(1) : 0}</p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {loading &&
                            6 - blogers.length > 0 &&
                            new Array(6 - blogers.length).fill(null).map((item, index) => (
                                <div
                                    className={`choose_creative_block_items_item choose_creative_block_items_item_skeleton`}
                                    key={index}
                                >
                                    <div class="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            ))}



                    </div>
                </div>
                <div className="choose_creative_block_buttons">
                    <span onClick={() => navigate("/select_options")}>
                        Внести изменения в ТЗ
                    </span>
                    <div>
                        <span onClick={() => navigate(-1)}>Назад</span>
                        <MyButton
                            text={"Продолжить"}
                            icon={chevronRight}
                            disabled={!setSelectedBlogers.length}
                            onClick={() => {
                                //dispatch(setCreativesAction(selectedCreatives));
                                dispatch(setBlogersAction(selectedBloggers));
                               navigate("/choose_creative");
                               // navigate("/choose_text_photo");
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        appState: state.dataAppState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setBlogers: (data) => dispatch(setBlogersAction(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseBlogers);
